export const platinumStyles = {
	header: {
		backgroundColor: '#fcce01',
	},
	sidebar: {
		backgroundColor: '#212529',
		color: 'white',
	},
	title: {
		color: 'black',
	},
	button: {
		backgroundColor: '#152069',
		color: '#fff',
		fontWeight: 600,
		':hover': {
			backgroundColor: '#0083be',
		},
	},
	text: {
		color: '#00305e',
		buttonLoadingColor: '#FFFFFF',
	},
	table: {
		headerBackgroundColor: '#0046AD',
		headerTextColor: '#ffffff',
	},
	platformName: {
		name: 'Platinum Parking',
	},
	logo: {
		small: {
			src: '/platinum/platinum-icon-new-white.svg',
			height: 35,
			width: 35,
		},
		large: {
			src: '/platinum/platinum-logo-new-white.svg',
			height: 41,
			width: 150,
		},
	},
	favicon: {
		src: '/platinum/platinum-icon-new-black.svg',
	},
	socials: {
		x: 'https://twitter.com/ABMFacilityServ',
		linkedIn: 'https://www.linkedin.com/company/platinum-parking/',
	},
	siteUrl: 'https://platinumparking.com/',
	orgName: 'Platinum Parking',
};
